import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core'

import { UserContext } from '../../../auth/models/auth'

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class UserMenuComponent {
  @Input() languages: string[]
  @Input() user: UserContext
  @Input() salesRep: boolean
  @Input() admin: boolean

  @Output() onSelectCustomer = new EventEmitter()

  showUserMenu: boolean = false

  constructor(private elemRef: ElementRef){}

  @HostListener('document:click', ['$event', '$event.target'])
  outSideClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    if (!this.elemRef.nativeElement.contains(targetElement))
      this.showUserMenu = false
  }

  get fullname(): string {
    return this.user && this.user.fullname
  }

  selectCustomer() {
    this.onSelectCustomer.emit()
  }

  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
  }



}
